import styled from 'styled-components';

export const Text = styled.h1(props =>({
  fontSize: props.fontSize,
  color: props.color
}));